import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {AuthenticationService} from '../services/authentication.service';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    if (this.authenticationService.isLoggedIn()) {
      const currentUser = this.authenticationService.currentUserValue;

      // List of URLs that should use base_token instead of regular token
      const baseTokenUrls = [
        environment.url.api.congress.event,
      ];

      // Check if the current request URL matches any of the base_token URLs
      const useBaseToken = baseTokenUrls.some(url => request.url.startsWith(url));

      const authToken = useBaseToken ? environment.key.base_token : currentUser.token;

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
          'http-x-access-key': `${environment.key.http_access}`
        }
      });
    }
    return next.handle(request);
  }
}
